"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOwner = getOwner;
exports.getResolver = getResolver;
exports.getResolverWithLabelhash = getResolverWithLabelhash;
exports.getOwnerWithLabelHash = getOwnerWithLabelHash;
exports.getAddress = getAddress;
exports.getContent = getContent;
exports.getName = getName;
exports.setOwner = setOwner;
exports.setSubnodeOwner = setSubnodeOwner;
exports.setResolver = setResolver;
exports.setAddress = setAddress;
exports.setContent = setContent;
exports.setContenthash = setContenthash;
exports.checkSubdomain = checkSubdomain;
exports.createSubdomain = createSubdomain;
exports.deleteSubdomain = deleteSubdomain;
exports.getResolverDetails = getResolverDetails;
exports.claimAndSetReverseRecordName = claimAndSetReverseRecordName;
exports.setReverseRecordName = setReverseRecordName;
exports.getDomainDetails = getDomainDetails;
exports.registerTestdomain = registerTestdomain;
exports.expiryTimes = expiryTimes;
exports.getSubdomains = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _ens = require("./ens");

var _preimage = require("./preimage");

var _utils = require("./utils");

var _labelhash = require("./utils/labelhash");

var _contents = require("./utils/contents");

var _web = require("./web3");

var _ethers = require("ethers");

function getOwner(_x) {
  return _getOwner.apply(this, arguments);
}

function _getOwner() {
  _getOwner = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee2(name) {
    var _ref2, ENS, namehash, owner;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref2 = _context2.sent;
            ENS = _ref2.ENS;
            namehash = (0, _ens.getNamehash)(name);
            _context2.next = 7;
            return ENS.owner(namehash);

          case 7:
            owner = _context2.sent;
            return _context2.abrupt("return", owner);

          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getOwner.apply(this, arguments);
}

function getResolver(_x2) {
  return _getResolver.apply(this, arguments);
}

function _getResolver() {
  _getResolver = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee3(name) {
    var namehash, _ref3, ENS;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            namehash = (0, _ens.getNamehash)(name);
            _context3.next = 3;
            return (0, _ens.getENS)();

          case 3:
            _ref3 = _context3.sent;
            ENS = _ref3.ENS;
            return _context3.abrupt("return", ENS.resolver(namehash));

          case 6:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getResolver.apply(this, arguments);
}

function getResolverWithLabelhash(_x3, _x4) {
  return _getResolverWithLabelhash.apply(this, arguments);
}

function _getResolverWithLabelhash() {
  _getResolverWithLabelhash = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee4(labelhash, nodehash) {
    var _ref4, ENS, namehash;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref4 = _context4.sent;
            ENS = _ref4.ENS;
            _context4.next = 6;
            return (0, _ens.getNamehashWithLabelHash)(labelhash, nodehash);

          case 6:
            namehash = _context4.sent;
            return _context4.abrupt("return", ENS.resolver(namehash));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _getResolverWithLabelhash.apply(this, arguments);
}

function getOwnerWithLabelHash(_x5, _x6) {
  return _getOwnerWithLabelHash.apply(this, arguments);
}

function _getOwnerWithLabelHash() {
  _getOwnerWithLabelHash = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee5(labelhash, nodeHash) {
    var _ref5, ENS, namehash;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref5 = _context5.sent;
            ENS = _ref5.ENS;
            _context5.next = 6;
            return (0, _ens.getNamehashWithLabelHash)(labelhash, nodeHash);

          case 6:
            namehash = _context5.sent;
            return _context5.abrupt("return", ENS.owner(namehash));

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _getOwnerWithLabelHash.apply(this, arguments);
}

function getAddress(_x7) {
  return _getAddress.apply(this, arguments);
}

function _getAddress() {
  _getAddress = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee6(name) {
    var resolverAddr, namehash, _ref6, Resolver, addr;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return getResolver(name);

          case 2:
            resolverAddr = _context6.sent;

            if (!(parseInt(resolverAddr, 16) === 0)) {
              _context6.next = 5;
              break;
            }

            return _context6.abrupt("return", '0x00000000000000000000000000000000');

          case 5:
            namehash = (0, _ens.getNamehash)(name);
            _context6.prev = 6;
            _context6.next = 9;
            return (0, _ens.getResolverContract)(resolverAddr);

          case 9:
            _ref6 = _context6.sent;
            Resolver = _ref6.Resolver;
            _context6.next = 13;
            return Resolver.addr(namehash);

          case 13:
            addr = _context6.sent;
            return _context6.abrupt("return", addr);

          case 17:
            _context6.prev = 17;
            _context6.t0 = _context6["catch"](6);
            console.warn('Error getting addr on the resolver contract, are you sure the resolver address is a resolver contract?');
            return _context6.abrupt("return", '0x00000000000000000000000000000000');

          case 21:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[6, 17]]);
  }));
  return _getAddress.apply(this, arguments);
}

function getContent(_x8) {
  return _getContent.apply(this, arguments);
}

function _getContent() {
  _getContent = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee7(name) {
    var resolverAddr, namehash, _ref7, Resolver, contentHashSignature, isContentHashSupported, _decodeContenthash, protocolType, decoded, error, value, message;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return getResolver(name);

          case 2:
            resolverAddr = _context7.sent;

            if (!(parseInt(resolverAddr, 16) === 0)) {
              _context7.next = 5;
              break;
            }

            return _context7.abrupt("return", '0x00000000000000000000000000000000');

          case 5:
            _context7.prev = 5;
            namehash = (0, _ens.getNamehash)(name);
            _context7.next = 9;
            return (0, _ens.getResolverContract)(resolverAddr);

          case 9:
            _ref7 = _context7.sent;
            Resolver = _ref7.Resolver;
            contentHashSignature = _ethers.utils.solidityKeccak256(['string'], ['contenthash(bytes32)']).slice(0, 10);
            _context7.next = 14;
            return Resolver.supportsInterface(contentHashSignature);

          case 14:
            isContentHashSupported = _context7.sent;

            if (!isContentHashSupported) {
              _context7.next = 29;
              break;
            }

            _context7.t0 = _contents.decodeContenthash;
            _context7.next = 19;
            return Resolver.contenthash(namehash);

          case 19:
            _context7.t1 = _context7.sent;
            _decodeContenthash = (0, _context7.t0)(_context7.t1);
            protocolType = _decodeContenthash.protocolType;
            decoded = _decodeContenthash.decoded;
            error = _decodeContenthash.error;

            if (!error) {
              _context7.next = 26;
              break;
            }

            return _context7.abrupt("return", {
              value: _utils.emptyAddress,
              contentType: 'contenthash'
            });

          case 26:
            return _context7.abrupt("return", {
              value: "".concat(protocolType, "://").concat(decoded),
              contentType: 'contenthash'
            });

          case 29:
            _context7.next = 31;
            return Resolver.content(namehash);

          case 31:
            value = _context7.sent;
            return _context7.abrupt("return", {
              value: value,
              contentType: 'oldcontent'
            });

          case 33:
            _context7.next = 40;
            break;

          case 35:
            _context7.prev = 35;
            _context7.t2 = _context7["catch"](5);
            message = 'Error getting content on the resolver contract, are you sure the resolver address is a resolver contract?';
            console.warn(message, _context7.t2);
            return _context7.abrupt("return", {
              value: message,
              contentType: 'error'
            });

          case 40:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[5, 35]]);
  }));
  return _getContent.apply(this, arguments);
}

function getName(_x9) {
  return _getName.apply(this, arguments);
}

function _getName() {
  _getName = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee8(address) {
    var reverseNode, reverseNamehash, resolverAddr, _ref8, Resolver, name;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            reverseNode = "".concat(address.slice(2), ".addr.reverse");
            reverseNamehash = (0, _ens.getNamehash)(reverseNode);
            _context8.next = 4;
            return getResolver(reverseNode);

          case 4:
            resolverAddr = _context8.sent;

            if (!(parseInt(resolverAddr, 16) === 0)) {
              _context8.next = 7;
              break;
            }

            return _context8.abrupt("return", {
              name: null
            });

          case 7:
            _context8.prev = 7;
            _context8.next = 10;
            return (0, _ens.getResolverContract)(resolverAddr);

          case 10:
            _ref8 = _context8.sent;
            Resolver = _ref8.Resolver;
            _context8.next = 14;
            return Resolver.name(reverseNamehash);

          case 14:
            name = _context8.sent;
            return _context8.abrupt("return", {
              name: name
            });

          case 18:
            _context8.prev = 18;
            _context8.t0 = _context8["catch"](7);
            console.log("Error getting name for reverse record of ".concat(address), _context8.t0);

          case 21:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[7, 18]]);
  }));
  return _getName.apply(this, arguments);
}

function setOwner(_x10, _x11) {
  return _setOwner.apply(this, arguments);
}

function _setOwner() {
  _setOwner = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee9(name, newOwner) {
    var _ref9, ENS, namehash;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref9 = _context9.sent;
            ENS = _ref9.ENS;
            namehash = (0, _ens.getNamehash)(name);
            return _context9.abrupt("return", ENS.setOwner(namehash, newOwner));

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _setOwner.apply(this, arguments);
}

function setSubnodeOwner(_x12, _x13) {
  return _setSubnodeOwner.apply(this, arguments);
}

function _setSubnodeOwner() {
  _setSubnodeOwner = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee10(unnormalizedName, newOwner) {
    var _ref10, ENS, name, nameArray, label, node, labelhash, parentNamehash;

    return _regenerator["default"].wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref10 = _context10.sent;
            ENS = _ref10.ENS;
            name = (0, _ens.normalize)(unnormalizedName);
            nameArray = name.split('.');
            label = nameArray[0];
            node = nameArray.slice(1).join('.');
            labelhash = (0, _ens.getLabelhash)(label);
            parentNamehash = (0, _ens.getNamehash)(node);
            return _context10.abrupt("return", ENS.setSubnodeOwner(parentNamehash, labelhash, newOwner));

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _setSubnodeOwner.apply(this, arguments);
}

function setResolver(_x14, _x15) {
  return _setResolver.apply(this, arguments);
}

function _setResolver() {
  _setResolver = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee11(name, resolver) {
    var namehash, _ref11, ENS;

    return _regenerator["default"].wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            namehash = (0, _ens.getNamehash)(name);
            _context11.next = 3;
            return (0, _ens.getENS)();

          case 3:
            _ref11 = _context11.sent;
            ENS = _ref11.ENS;
            return _context11.abrupt("return", ENS.setResolver(namehash, resolver));

          case 6:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _setResolver.apply(this, arguments);
}

function setAddress(_x16, _x17) {
  return _setAddress.apply(this, arguments);
}

function _setAddress() {
  _setAddress = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee12(name, address) {
    var namehash, resolverAddr, _ref12, Resolver;

    return _regenerator["default"].wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            namehash = (0, _ens.getNamehash)(name);
            _context12.next = 3;
            return getResolver(name);

          case 3:
            resolverAddr = _context12.sent;
            _context12.next = 6;
            return (0, _ens.getResolverContract)(resolverAddr);

          case 6:
            _ref12 = _context12.sent;
            Resolver = _ref12.Resolver;
            return _context12.abrupt("return", Resolver.setAddr(namehash, address));

          case 9:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _setAddress.apply(this, arguments);
}

function setContent(_x18, _x19) {
  return _setContent.apply(this, arguments);
}

function _setContent() {
  _setContent = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee13(name, content) {
    var namehash, resolverAddr, _ref13, Resolver;

    return _regenerator["default"].wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            namehash = (0, _ens.getNamehash)(name);
            _context13.next = 3;
            return getResolver(name);

          case 3:
            resolverAddr = _context13.sent;
            _context13.next = 6;
            return (0, _ens.getResolverContract)(resolverAddr);

          case 6:
            _ref13 = _context13.sent;
            Resolver = _ref13.Resolver;
            return _context13.abrupt("return", Resolver.setContent(namehash, content));

          case 9:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _setContent.apply(this, arguments);
}

function setContenthash(_x20, _x21) {
  return _setContenthash.apply(this, arguments);
}

function _setContenthash() {
  _setContenthash = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee14(name, content) {
    var encodedContenthash, namehash, resolverAddr, _ref14, Resolver;

    return _regenerator["default"].wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            encodedContenthash = (0, _contents.encodeContenthash)(content);
            namehash = (0, _ens.getNamehash)(name);
            _context14.next = 4;
            return getResolver(name);

          case 4:
            resolverAddr = _context14.sent;
            _context14.next = 7;
            return (0, _ens.getResolverContract)(resolverAddr);

          case 7:
            _ref14 = _context14.sent;
            Resolver = _ref14.Resolver;
            return _context14.abrupt("return", Resolver.setContenthash(namehash, encodedContenthash));

          case 10:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14);
  }));
  return _setContenthash.apply(this, arguments);
}

function checkSubdomain(_x22, _x23) {
  return _checkSubdomain.apply(this, arguments);
}

function _checkSubdomain() {
  _checkSubdomain = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee15(subdomain, domain) {
    var _ref15, ENS;

    return _regenerator["default"].wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.next = 2;
            return (0, _ens.getENS)();

          case 2:
            _ref15 = _context15.sent;
            ENS = _ref15.ENS;
            return _context15.abrupt("return", ENS.owner(subdomain + '.' + domain));

          case 5:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15);
  }));
  return _checkSubdomain.apply(this, arguments);
}

function createSubdomain(_x24) {
  return _createSubdomain.apply(this, arguments);
}

function _createSubdomain() {
  _createSubdomain = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee16(domain) {
    var account;
    return _regenerator["default"].wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.next = 2;
            return (0, _web.getAccount)();

          case 2:
            account = _context16.sent;
            _context16.prev = 3;
            return _context16.abrupt("return", setSubnodeOwner(domain, account));

          case 7:
            _context16.prev = 7;
            _context16.t0 = _context16["catch"](3);
            console.log('error creating subdomain', _context16.t0);

          case 10:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[3, 7]]);
  }));
  return _createSubdomain.apply(this, arguments);
}

function deleteSubdomain(_x25) {
  return _deleteSubdomain.apply(this, arguments);
}

function _deleteSubdomain() {
  _deleteSubdomain = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee17(name) {
    var resolver, account, tx, tx2;
    return _regenerator["default"].wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.next = 2;
            return getResolver(name);

          case 2:
            resolver = _context17.sent;
            _context17.next = 5;
            return (0, _web.getAccount)();

          case 5:
            account = _context17.sent;

            if (!(parseInt(resolver, 16) !== 0)) {
              _context17.next = 17;
              break;
            }

            _context17.next = 9;
            return setSubnodeOwner(name, account);

          case 9:
            tx = _context17.sent;
            _context17.next = 12;
            return tx.wait();

          case 12:
            _context17.next = 14;
            return setResolver(name, 0);

          case 14:
            tx2 = _context17.sent;
            _context17.next = 17;
            return tx2.wait();

          case 17:
            _context17.prev = 17;
            return _context17.abrupt("return", setSubnodeOwner(name, '0x0000000000000000000000000000000000000000'));

          case 21:
            _context17.prev = 21;
            _context17.t0 = _context17["catch"](17);
            console.log('error deleting subdomain', _context17.t0);

          case 24:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[17, 21]]);
  }));
  return _deleteSubdomain.apply(this, arguments);
}

function getResolverDetails(_x26) {
  return _getResolverDetails.apply(this, arguments);
}

function _getResolverDetails() {
  _getResolverDetails = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee18(node) {
    var addrPromise, contentPromise, _ref16, _ref17, addr, content;

    return _regenerator["default"].wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            addrPromise = getAddress(node.name);
            contentPromise = getContent(node.name);
            _context18.next = 5;
            return Promise.all([addrPromise, contentPromise]);

          case 5:
            _ref16 = _context18.sent;
            _ref17 = (0, _slicedToArray2["default"])(_ref16, 2);
            addr = _ref17[0];
            content = _ref17[1];
            return _context18.abrupt("return", (0, _objectSpread2["default"])({}, node, {
              addr: addr,
              content: content.value,
              contentType: content.contentType
            }));

          case 12:
            _context18.prev = 12;
            _context18.t0 = _context18["catch"](0);
            return _context18.abrupt("return", (0, _objectSpread2["default"])({}, node, {
              addr: '0x0',
              content: '0x0',
              contentType: 'error'
            }));

          case 15:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 12]]);
  }));
  return _getResolverDetails.apply(this, arguments);
}

function claimAndSetReverseRecordName(_x27) {
  return _claimAndSetReverseRecordName.apply(this, arguments);
}

function _claimAndSetReverseRecordName() {
  _claimAndSetReverseRecordName = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee19(name) {
    var overrides,
        _ref18,
        reverseRegistrar,
        networkId,
        gasLimit,
        _args19 = arguments;

    return _regenerator["default"].wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            overrides = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : {};
            _context19.next = 3;
            return (0, _ens.getReverseRegistrarContract)();

          case 3:
            _ref18 = _context19.sent;
            reverseRegistrar = _ref18.reverseRegistrar;
            _context19.next = 7;
            return (0, _web.getNetworkId)();

          case 7:
            networkId = _context19.sent;

            if (!(parseInt(networkId) > 1000)) {
              _context19.next = 13;
              break;
            }

            _context19.next = 11;
            return reverseRegistrar.estimate.setName(name);

          case 11:
            gasLimit = _context19.sent;
            overrides = (0, _objectSpread2["default"])({
              gasLimit: gasLimit.toNumber() * 2
            }, overrides);

          case 13:
            return _context19.abrupt("return", reverseRegistrar.setName(name, overrides));

          case 14:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19);
  }));
  return _claimAndSetReverseRecordName.apply(this, arguments);
}

function setReverseRecordName(_x28) {
  return _setReverseRecordName.apply(this, arguments);
}

function _setReverseRecordName() {
  _setReverseRecordName = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee20(name) {
    var account, reverseNode, resolverAddress, _ref19, Resolver, namehash;

    return _regenerator["default"].wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return (0, _web.getAccount)();

          case 2:
            account = _context20.sent;
            reverseNode = "".concat(account.slice(2), ".addr.reverse");
            _context20.next = 6;
            return getResolver(reverseNode);

          case 6:
            resolverAddress = _context20.sent;
            _context20.next = 9;
            return (0, _ens.getResolverContract)(resolverAddress);

          case 9:
            _ref19 = _context20.sent;
            Resolver = _ref19.Resolver;
            namehash = (0, _ens.getNamehash)(reverseNode);
            return _context20.abrupt("return", Resolver.setName(namehash, name));

          case 13:
          case "end":
            return _context20.stop();
        }
      }
    }, _callee20);
  }));
  return _setReverseRecordName.apply(this, arguments);
}

function getDomainDetails(_x29) {
  return _getDomainDetails.apply(this, arguments);
}

function _getDomainDetails() {
  _getDomainDetails = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee21(name) {
    var nameArray, labelhash, _ref20, _ref21, owner, resolver, node, hasResolver;

    return _regenerator["default"].wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            nameArray = name.split('.');
            labelhash = (0, _ens.getLabelhash)(nameArray[0]);
            _context21.next = 4;
            return Promise.all([getOwner(name), getResolver(name)]);

          case 4:
            _ref20 = _context21.sent;
            _ref21 = (0, _slicedToArray2["default"])(_ref20, 2);
            owner = _ref21[0];
            resolver = _ref21[1];
            node = {
              name: name,
              label: nameArray[0],
              labelhash: labelhash,
              owner: owner,
              resolver: resolver
            };
            hasResolver = parseInt(node.resolver, 16) !== 0;

            if (!hasResolver) {
              _context21.next = 12;
              break;
            }

            return _context21.abrupt("return", getResolverDetails(node));

          case 12:
            return _context21.abrupt("return", (0, _objectSpread2["default"])({}, node, {
              addr: null,
              content: null
            }));

          case 13:
          case "end":
            return _context21.stop();
        }
      }
    }, _callee21);
  }));
  return _getDomainDetails.apply(this, arguments);
}

var getSubdomains =
/*#__PURE__*/
function () {
  var _ref = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee(name) {
    var startBlock, namehash, rawLogs, flattenedLogs, logs, labelhashes, remoteLabels, localLabels, labels, ownerPromises;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _utils.ensStartBlock)();

          case 2:
            startBlock = _context.sent;
            namehash = (0, _ens.getNamehash)(name);
            _context.next = 6;
            return (0, _ens.getENSEvent)('NewOwner', {
              topics: [namehash],
              fromBlock: startBlock
            });

          case 6:
            rawLogs = _context.sent;
            flattenedLogs = rawLogs.map(function (log) {
              return log.values;
            });
            flattenedLogs.reverse();
            logs = (0, _utils.uniq)(flattenedLogs, 'label');
            labelhashes = logs.map(function (log) {
              return log.label;
            });
            _context.next = 13;
            return _preimage.decryptHashes.apply(void 0, (0, _toConsumableArray2["default"])(labelhashes));

          case 13:
            remoteLabels = _context.sent;
            localLabels = _utils.checkLabels.apply(void 0, (0, _toConsumableArray2["default"])(labelhashes));
            labels = (0, _utils.mergeLabels)(localLabels, remoteLabels);
            ownerPromises = labels.map(function (label) {
              return getOwner("".concat(label, ".").concat(name));
            });
            return _context.abrupt("return", Promise.all(ownerPromises).then(function (owners) {
              return owners.map(function (owner, index) {
                return {
                  label: labels[index],
                  labelhash: logs[index].label,
                  decrypted: labels[index] !== null,
                  node: name,
                  name: "".concat(labels[index] || (0, _labelhash.encodeLabelhash)(logs[index].label), ".").concat(name),
                  owner: owner
                };
              });
            }));

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getSubdomains(_x30) {
    return _ref.apply(this, arguments);
  };
}();

exports.getSubdomains = getSubdomains;

function registerTestdomain(_x31) {
  return _registerTestdomain.apply(this, arguments);
}

function _registerTestdomain() {
  _registerTestdomain = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee22(label) {
    var _ref22, registrar, labelhash, account;

    return _regenerator["default"].wrap(function _callee22$(_context22) {
      while (1) {
        switch (_context22.prev = _context22.next) {
          case 0:
            _context22.next = 2;
            return (0, _ens.getTestRegistrarContract)();

          case 2:
            _ref22 = _context22.sent;
            registrar = _ref22.registrar;
            labelhash = (0, _ens.getLabelhash)(label);
            _context22.next = 7;
            return (0, _web.getAccount)();

          case 7:
            account = _context22.sent;
            return _context22.abrupt("return", registrar.register(labelhash, account));

          case 9:
          case "end":
            return _context22.stop();
        }
      }
    }, _callee22);
  }));
  return _registerTestdomain.apply(this, arguments);
}

function expiryTimes(_x32, _x33) {
  return _expiryTimes.apply(this, arguments);
}

function _expiryTimes() {
  _expiryTimes = (0, _asyncToGenerator2["default"])(
  /*#__PURE__*/
  _regenerator["default"].mark(function _callee23(label, owner) {
    var _ref23, registrar, labelhash, result;

    return _regenerator["default"].wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _context23.next = 2;
            return (0, _ens.getTestRegistrarContract)();

          case 2:
            _ref23 = _context23.sent;
            registrar = _ref23.registrar;
            labelhash = (0, _ens.getLabelhash)(label);
            _context23.next = 7;
            return registrar.expiryTimes(labelhash);

          case 7:
            result = _context23.sent;

            if (!(result > 0)) {
              _context23.next = 10;
              break;
            }

            return _context23.abrupt("return", new Date(result * 1000));

          case 10:
          case "end":
            return _context23.stop();
        }
      }
    }, _callee23);
  }));
  return _expiryTimes.apply(this, arguments);
}